// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.breadcrumb[data-v-cc995e54] {\n  padding: 14px;\n  line-height: 40px;\n  border-bottom: 1px solid #e3e9f5;\n}\n[data-v-cc995e54].el-breadcrumb__item:last-child .el-breadcrumb__inner {\n  color: #ff6101;\n}\n", ""]);
// Exports
module.exports = exports;
